import { useState, useEffect } from 'react'
import Sidebar from './Sidebar'
import InvoicesPage from './InvoicesPage'
import ChangePasswordPage from './ChangePasswordPage'
import * as API from '../services/api'

function MainApp({ currentTIN, onLogout }) {
  const [currentCompany, setCurrentCompany] = useState('spn')
  const [currentPage, setCurrentPage] = useState('invoices')
  const [companyTIN, setCompanyTIN] = useState(currentTIN)
  const [isLoadingTIN, setIsLoadingTIN] = useState(false)

  useEffect(() => {
    // Handle hash changes for routing
    const handleHashChange = () => {
      const hash = window.location.hash
      if (hash === '#invoices-ssa') {
        setCurrentCompany('ssa')
        setCurrentPage('invoices')
      } else if (hash === '#change-password') {
        setCurrentPage('change-password')
      } else {
        setCurrentCompany('spn')
        setCurrentPage('invoices')
      }
    }

    // Set initial company based on hash
    handleHashChange()

    // Listen for hash changes
    window.addEventListener('hashchange', handleHashChange)
    return () => window.removeEventListener('hashchange', handleHashChange)
  }, [])

  // Fetch TIN when company changes
  useEffect(() => {
    const fetchTIN = async () => {
      setIsLoadingTIN(true)
      try {
        const tin = await API.getTIN(currentCompany)
        setCompanyTIN(tin)
      } catch (error) {
        console.error('Failed to fetch TIN:', error)
        // Keep the current TIN if fetch fails
      } finally {
        setIsLoadingTIN(false)
      }
    }

    fetchTIN()
  }, [currentCompany])

  const renderPage = () => {
    switch (currentPage) {
      case 'change-password':
        return <ChangePasswordPage />
      default:
        return (
          <InvoicesPage 
            currentTIN={companyTIN} 
            company={currentCompany}
            isLoadingTIN={isLoadingTIN}
          />
        )
    }
  }

  return (
    <div className="flex h-screen">
      <Sidebar onLogout={onLogout} />
      <main className="flex-1 overflow-auto p-8">
        {renderPage()}
      </main>
    </div>
  )
}

export default MainApp
